module.exports = __webpack_public_path__ + "img/logo-demo3.7a84e964.png";